import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const FormSkeleton = memo(() => {
  return (
    <div className="glass-card">
      {/* Title skeleton */}
      <Skeleton className="h-7 w-48 mb-6" />
      
      <div className="space-y-5">
        {/* Name and Phone row */}
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <Skeleton className="h-4 w-16 mb-2" />
            <Skeleton className="h-12 w-full rounded-xl" />
          </div>
          <div>
            <Skeleton className="h-4 w-20 mb-2" />
            <Skeleton className="h-12 w-full rounded-xl" />
          </div>
        </div>
        
        {/* Email */}
        <div>
          <Skeleton className="h-4 w-12 mb-2" />
          <Skeleton className="h-12 w-full rounded-xl" />
        </div>
        
        {/* Service select */}
        <div>
          <Skeleton className="h-4 w-36 mb-2" />
          <Skeleton className="h-12 w-full rounded-xl" />
        </div>
        
        {/* Message textarea */}
        <div>
          <Skeleton className="h-4 w-20 mb-2" />
          <Skeleton className="h-28 w-full rounded-xl" />
        </div>
        
        {/* Submit button */}
        <Skeleton className="h-14 w-full rounded-xl" />
        
        {/* Privacy text */}
        <Skeleton className="h-3 w-64 mx-auto" />
      </div>
    </div>
  );
});

FormSkeleton.displayName = 'FormSkeleton';

export default FormSkeleton;
